export default __webpack_public_path__ + "static/media/desk-2.72805067.svg";